module.exports = __webpack_public_path__ + "static/media/cart.bdf3fb2b.svg";